import type { File as EvidenceUploadFile } from 'src/components/moleculesLegacy/FileUpload';
import type {
  DynamicQuestionUploadedFile,
  QaAnswerAttachmentRef,
} from 'src/utils/dynamicQuestionUploadedFiles';

export type { DynamicQuestionUploadedFile, QaAnswerAttachmentRef };

export enum QuestionTypeTypeKey {
  SHORT_TEXT = 'short_text',
  NUMBER = 'number',
  LONG_TEXT = 'long_text',
  DROPDOWN = 'dropdown',
  RADIO = 'radio',
  CHECKBOX = 'checkbox',
  MULTIPLE_CHOICE = 'multiple_choice',
  DATA_GRID = 'data_grid',
  FILE_UPLOAD = 'file_upload',
  DATE_TIME = 'date_time',
  TIME = 'time',
  DATABASE_FIELD = 'database_field',
}

export interface DynamicQuestionOption {
  id?: string | null;
  optionText?: string | null;
  optionOrder?: number | null;
}

export interface DynamicQuestionType {
  id?: string | null;
  typeKey?: QuestionTypeTypeKey | string | null;
  label?: string | null;
  allowsOptions?: boolean | null;
}

export interface DynamicQuestionDataGridConfig {
  columns?: Array<{ key: string; label: string; type: string }>;
  minRows?: number | null;
  maxRows?: number | null;
  addRowLabel?: string | null;
  removeRowLabel?: string | null;
}

export interface DynamicQuestionData {
  id?: string | null;
  questionText?: string | null;
  description?: string | null;
  questionType?: DynamicQuestionType | null;
  isRequired?: boolean | null;
  options?: DynamicQuestionOption[] | null;
  dataGridConfig?: DynamicQuestionDataGridConfig | null;
  attachmentAllowed?: boolean | null;
  allowMultiSelect?: boolean | null;
  databaseFieldSubType?: {
    subTypeKey?: string | null;
  } | null;
  isFlagged?: boolean | null;
}

export type DynamicQuestionEvidenceFile = EvidenceUploadFile;

export interface DynamicQuestionAnswerValue {
  text?: string;
  selectedOptionId?: string;
  selectedOptionIds?: string[];
  dataGridRows?: Record<string, unknown>[];
  fileNames?: string[];
  evidenceUploadFiles?: DynamicQuestionEvidenceFile[];
  uploadedFiles?: DynamicQuestionUploadedFile[];
  /** When disclosure payload includes QA attachment metadata (see getDisclosureCaseById). */
  qaAnswerAttachments?: QaAnswerAttachmentRef[];
  dateTimeUnsure?: boolean;
  textValues?: string[];
  isFlagged?: boolean | null;
  isSanitized?: boolean;
}
